/* aurapik cart — delegated coupon apply (survives Dawn cart re-renders) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-ap-coupon-apply]');
  if (!btn) return;
  var box = btn.closest('.ap-coupon');
  var inp = box && box.querySelector('[data-ap-coupon]');
  var code = inp && (inp.value || '').trim();
  if (!code) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window.location.href = root + 'discount/' + encodeURIComponent(code);
});
